function formatoDinero(number) {
    let res = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(number);
    return res;

}

function formatoNum(number) {
    let res = new Intl.NumberFormat('es-MX').format(number);
    return res;
}

const limpiarTexto = (texto) => {
    // Define los caracteres que deseas eliminar
    var caracteresAEliminar = [',', '"', '"', '"', '/', '', "'", '!', '?', '#', '$', '%', '&', '*', '+', '=', '@', '[', ']', '{', '}', '(', ')', ':', ';', '<', '>', '|', '\\', '`', '^', '~'];

    // Itera sobre cada carácter y reemplázalo con una cadena vacía
    caracteresAEliminar.forEach(function (caracter) {
        texto = texto.split(caracter).join('');
    });
    
    // Reemplazar vocales con acentos
    texto = texto.split('ó').join('o');
    texto = texto.split('á').join('a');
    texto = texto.split('é').join('e');
    texto = texto.split('í').join('i');
    texto = texto.split('ú').join('u');
    texto = texto.split('ü').join('u');
    texto = texto.split('ñ').join('n');
    texto = texto.split('Á').join('A');
    texto = texto.split('É').join('E');
    texto = texto.split('Í').join('I');
    texto = texto.split('Ó').join('O');
    texto = texto.split('Ú').join('U');
    texto = texto.split('Ü').join('U');
    texto = texto.split('Ñ').join('N');

    return texto;
}

export { formatoDinero, formatoNum, limpiarTexto }